<template>
  <!-- Suspended -->
  <v-content class="candidate email-confirmation banner" v-if="user && user.isSuspended">
    <v-alert :color="themes.candidate.light.error" :value="user.isSuspended">
      <v-container class="pa-0">
        <v-layout>
          <v-icon dark left>mdi-alert-circle</v-icon>
          <div class="py-2 subheading">Your profile has been <strong>suspended</strong>.</div>
          <v-spacer />
          <v-menu
            :color="themes.candidate.light.tooltip"
            class="px-1"
            bottom
            left
            open-on-hover
            nudge-bottom="30"
            max-width="300"
          >
            <v-btn dark outline small slot="activator" @click="">
              <v-icon left>mdi-help-circle</v-icon> Help
            </v-btn>
            <v-card :class="themes.candidate.light.dialogTitle">
              <v-card-text>
                <p class="font-weight-bold pb-0">Why did this happen?</p>
                Someone screened your profile and found irregularities with the information that you
                provided.

                <p class="font-weight-bold mt-4 pb-0">What does it mean?</p>
                You will have limited access to Leaply until your account is unsuspended. All your
                applications will now show as “reported for irregularities” by means of a flag. The
                flag will disappear once you have rectified the relevant sections. Note that another
                serious infringement will result in your profile being blocked on Leaply.

                <p class="font-weight-bold pb-0">How do I resolve this?</p>
                Please visit your Leaply dashboard, check the action items list and click through to
                the section of your profile that was reported. Ensure that you update the relevant
                section with the correct information speedily.
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-container>
    </v-alert>
  </v-content>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },
}
</script>
